<template>
  <div id="company">
    <form-layout
      title="Company"
      submit-text="Save"
      :show-loading="updatingForm"
      :show-reset="false"
      submit-button-name="update-company"
      @onSubmit="update"
    >
      <template slot="form-header">
        <div class="d-flex justify-content-center mb-2">
          <div class="d-flex flex-column justify-content-start">
            <div class="text-center mb-2">
              <sikanii-profile-photo
                v-show="!updatingLogo && logoUrl"
                size="80"
                :photo="logoUrl"
              />
              <b-avatar
                v-show="!updatingLogo && !logoUrl"
                size="80px"
                variant="light-primary"
              />
              <b-spinner
                v-show="updatingLogo"
                style="width: 80px; height: 80px;"
                variant="primary"
              />
            </div>
            <sikanii-file-button
              label="Logo"
              :loading="updatingLogo"
              @onFileUpload="uploadLogo"
            />
          </div>
        </div>

      </template>
      <template slot="form-elements">
        <div class="col-md-4">
          <sikanii-input
            v-model="company.name"
            name="name"
            label="Name"
            rules="required"
          />
        </div>
        <div class="col-md-4">
          <sikanii-input
            v-model="company.phone"
            name="phone"
            label="Phone"
            rules="required|max_length:15"
          />
        </div>
        <div class="col-md-4">
          <sikanii-input
            v-model="company.email"
            name="email"
            label="Email"
            rules="required|email"
          />
        </div>
        <div class="col-md-4">
          <sikanii-select
            v-model="company.country_id"
            name="country"
            label="Country"
            rules="required"
            label-name="name"
            value-name="id"
            :options="countries"
          />
        </div>
        <div class="col-md-4">
          <sikanii-select
            v-model="company.region_id"
            name="region"
            label="Region"
            rules="required"
            label-name="name"
            value-name="id"
            :options="filteredRegions"
          />
        </div>
        <div class="col-md-4">
          <sikanii-select
            v-model="company.city_id"
            name="city"
            label="City"
            rules="required"
            label-name="name"
            value-name="id"
            :options="filteredCities"
          />
        </div>
        <div class="col-md-4">
          <sikanii-input
            v-model="company.town"
            name="town"
            label="Town"
            placeholder="Town"
            rules="max_length:100"
          />
        </div>
        <div class="col-md-4">
          <sikanii-input
            v-model="company.address"
            name="address"
            label="Address"
            placeholder="Address"
          />
        </div>
        <div class="col-12">
          <error-display :error="error" />
        </div>
      </template>
    </form-layout>
  </div>
</template>

<script>
import {
  BAvatar, BSpinner, VBTooltip,
} from 'bootstrap-vue'
import FormLayout from '@/layouts/FormLayout.vue'
import SikaniiInput from '@/layouts/components/SikaniiInput.vue'
import SikaniiFileButton from '@/layouts/components/SikaniiFileButton.vue'
import showToast from '@/libs/mixins/showToast'
import ErrorDisplay from '@/layouts/components/ErrorDisplay.vue'
import SikaniiProfilePhoto from '@/layouts/components/SikaniiProfilePhoto.vue'
import SikaniiSelect from '@/layouts/components/SikaniiSelect.vue'

export default {
  name: 'Company',
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    SikaniiSelect,
    SikaniiProfilePhoto,
    ErrorDisplay,
    SikaniiFileButton,
    SikaniiInput,
    FormLayout,
    BAvatar,
    BSpinner,
  },
  mixins: [showToast],
  data() {
    return {
      error: {},
      company: {
        id: null,
        name: null,
        email: null,
        phone: null,
        country_id: null,
        region_id: null,
        city_id: null,
        town: null,
        address: null,
      },
      updatingLogo: false,
      updatingForm: false,
    }
  },
  computed: {
    // eslint-disable-next-line class-methods-use-this
    logoUrl() {
      return this.$store.getters['auth/companyLogo']
    },
    companyInfo() {
      return this.$store.getters['auth/company']
    },
    countries() {
      return this.$store.getters['auth/countries']
    },
    regions() {
      return this.$store.getters['auth/regions']
    },
    cities() {
      return this.$store.getters['auth/cities']
    },
    filteredRegions() {
      return this.regions.filter(r => +r.country_id === +this.company.country_id)
    },
    filteredCities() {
      return this.cities.filter(c => +c.region_id === +this.company.region_id)
    },
  },
  watch: {
    companyInfo(company) {
      this.company = { ...company }
    },
  },
  mounted() {
    this.company = {
      ...this
        .companyInfo,
    }
  },
  methods: {
    uploadLogo(e) {
      this.updateLogo(e.file)
    },
    update() {
      this.error = {}
      this.updatingForm = true
      this.$http.put(`company-account/update-info/${this.company.id}`, this.company).then(res => {
        this.updatingForm = false
        this.$store.commit('auth/updateCompany', res.data)
        this.showSuccess('Saved Successfully')
      }).catch(err => {
        this.updatingForm = false
        console.log(err)
        this.error = err
        this.showError('Something went wrong, please try again')
      })
    },
    updateLogo(logo) {
      this.updatingLogo = true
      const fd = new FormData()
      fd.append('logo', logo)
      this.$http.post('company-account/update-logo', fd).then(res => {
        this.updatingLogo = false
        this.$store.commit('auth/updateLogo', res.data)
        this.showSuccess('Saved Successfully')
      }).catch(err => {
        this.updatingLogo = false
        console.log(err)
        this.showError('Something went wrong, please try again')
      })
    },
  },
}
</script>
